import cn from 'classnames';
import { FontIcon, FontIconName } from '../FontIcon';
import styles from './cornermarker.module.sass';

export type CornerMarkerIcon = 'heart' | 'bell' | 'lock';
export type CornerMarkerSize = 'm' | 's' | 'auto';

export interface CornerMarkerProps {
    icon: CornerMarkerIcon;
    size?: CornerMarkerSize;
    label?: string;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const glyphs: Record<CornerMarkerIcon, FontIconName> = {
    heart: 'heart-filled',
    bell: 'bell-filled',
    lock: 'lock-filled',
};

/** Figma "Top Labels/M/My Watchlist" and "Top Labels/M/Reminder Marker" */
export const CornerMarker = ({ icon, size = 'm', label, className, onClick }: CornerMarkerProps) => {
    const glyph = <FontIcon name={glyphs[icon]} size="x-small" md="x-small" className={styles.glyph} />;

    return onClick ? (
        <button
            type="button"
            className={cn(styles.marker, styles[size], styles.action, className)}
            aria-label={label}
            onClick={onClick}
        >
            {glyph}
        </button>
    ) : (
        <span
            className={cn(styles.marker, styles[size], className)}
            role={label ? 'img' : undefined}
            aria-label={label}
            aria-hidden={label ? undefined : true}
        >
            {glyph}
        </span>
    );
};
